import { SettingsSection } from '../../../../../base/components/SettingsSection/SettingsSection';
import * as React from 'react';
import {
    CARD_ESTIMATE_AND_SPENT_TIME,
    CARD_ESTIMATE_SPENT_TOOLTIP,
    CARD_ESTIMATE_TRACKER_TOOLTIP,
    CARD_SPENT_TIME_LABEL_TEXT,
} from './constants';
import { ICardEstimateAndSpentTimeProps } from './types';
import { Button, Icon, Input } from 'kui';
import './_CardEstimateAndSpentTime.scss';
import { ESettingsSectionType } from '../../../../../base/components/SettingsSection/types';
import { CLASS_CARD_DETAILS, CLASS_CARD_DETAILS_SECTION } from '../../../constants';
import { AsidePanelContext } from '../../../../asidePanel/components/AsidePanel/constants';
import { EAsidePanelProperty } from '../../../../asidePanel/components/AsidePanel/types';
import { CardEstimate } from '../CardEstimate/CardEstimate';
import { CLASS_SETTINGS_SECTION } from '../../../../../base/components/SettingsSection/constants';
import { TimeTrackerHelper } from '../../../../../dialogs/timeTrackerDialog/helpers/TimeTrackerHelper';

export function CardEstimateAndSpentTimeSection({
    estimateStr,
    isDefaultProperty,
    isRequired,
    spentTime = '',
    start,
    onEstimateChange,
    sectionType,
    workHoursInDay,
    onClose,
    onEstimateError,
    onShowBoardLimitSnackbarIfNeeded,
    onToggleSpent,
}: ICardEstimateAndSpentTimeProps) {
    const isPopup = sectionType === ESettingsSectionType.POPUP;
    const isReadonly = sectionType === ESettingsSectionType.DISALLOW || sectionType === ESettingsSectionType.READONLY;

    const className = CLASS_CARD_DETAILS + '-times';
    const classEstimate = className + '__estimate';
    const classSpent = className + '__spent';

    const { isCommentsColumn, addShowedProperty, showedProperties } = React.useContext(AsidePanelContext);

    const [isShow, setShow] = React.useState(null);
    const [isOpen, setOpen] = React.useState(null);
    const [value, setValue] = React.useState('');

    React.useEffect(() => {
        if (estimateStr || spentTime || isDefaultProperty) {
            if (estimateStr || spentTime) {
                setOpen(false);
            }
            setShow(true);
            addShowedProperty(EAsidePanelProperty.CARD_ESTIMATE, isCommentsColumn);
        }
    }, [estimateStr, spentTime, isDefaultProperty]);

    const timerRef = React.useRef(null);

    function updateInputValue() {
        if (timerRef.current) clearTimeout(timerRef.current);
        if (start) {
            timerRef.current = setTimeout(updateInputValue, 1000);
        }
        if (!start) {
            setValue(spentTime || '');
            return;
        }

        const delta = TimeTrackerHelper.calcTotalSeconds(start);
        let timerString = TimeTrackerHelper.formatSecondsToString(delta, workHoursInDay, true);
        setValue(timerString);
    }

    React.useEffect(() => {
        updateInputValue();

        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [start, workHoursInDay]);

    React.useEffect(() => {
        setValue(spentTime);
    }, [spentTime]);

    if (
        !estimateStr && !spentTime && sectionType === ESettingsSectionType.READONLY ||
        !isShow && !showedProperties.has(EAsidePanelProperty.CARD_ESTIMATE)
    ) {
        return;
    }

    const content = <div className={className}>
        <div onClick={onShowBoardLimitSnackbarIfNeeded}>
            <CardEstimate
                estimateStr={estimateStr}
                sectionType={sectionType}
                workHoursInDay={workHoursInDay}
                onEstimateChange={onEstimateChange}
                onError={onEstimateError}
                isRequired={isRequired}
            />
        </div>
        <div className={classSpent + '-wrapper'} onClick={onShowBoardLimitSnackbarIfNeeded}>
            {!isReadonly && <Button
                className={classSpent + '-button'}
                variant={'icon'}
                onClick={onToggleSpent}
                tooltip={{
                    direction: 'up',
                    value: CARD_ESTIMATE_TRACKER_TOOLTIP,
                }}
            >
                <Icon className={classSpent + '-' + (start ? 'stop' : 'play')} size={16} xlink={start ? 'color-tag' : 'play'}/>
            </Button>}
            <Input
                tooltip={{
                    direction: 'up',
                    value: CARD_ESTIMATE_SPENT_TOOLTIP,
                }}
                className={`
                    ${classSpent}
                    ${start ? classSpent + '--active' : ''}
                    ${isReadonly ? classSpent + '--readonly' : ''}
                `}
                readOnly={true}
                autosize={false}
                value={value}
                placeholder={CARD_SPENT_TIME_LABEL_TEXT}
            />
        </div>
    </div>;

    return (
        <SettingsSection
            className={`
                ${CLASS_CARD_DETAILS_SECTION}
                ${CLASS_CARD_DETAILS_SECTION}--estimate
                ${!isOpen && !estimateStr && !spentTime ? CLASS_SETTINGS_SECTION + '--empty' : ''}
            `}
            focusSelector={'.' + classEstimate}
            sectionType={sectionType}
            title={CARD_ESTIMATE_AND_SPENT_TIME}
            titleButton={null}
            isOpened={isOpen || isPopup || !isPopup && !estimateStr && !spentTime && start}
            onAddClosed={() => {
                if (onClose) onClose();
                setOpen(false);
            }}
            onAddOpened={() => setOpen(true)}
            isAddWide={!isPopup}
            addComponent={isPopup || estimateStr || spentTime ? null
                : content}
        >
            {!isPopup && (isOpen || !estimateStr && !spentTime) ? <div /> : content}
        </SettingsSection>
    );
}
